var _circle, _g, _rect, _rect2, _rect3, _rect4, _circle2, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _circle3, _path3, _path4, _rect0, _rect1, _rect10, _rect11, _rect12, _g2, _circle4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembershipEmptyStateEdit = function SvgMembershipEmptyStateEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 124 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F7F9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#MembershipEmptyStateEdit_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.286,
    height: 45.732,
    x: 37.029,
    y: 90.514,
    fill: "#fff",
    rx: 5,
    transform: "rotate(-90 37.029 90.514)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.971,
    height: 5.38,
    x: 42.409,
    y: 70.787,
    fill: "#E6E9ED",
    rx: 2.69
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.347,
    height: 5.38,
    x: 42.409,
    y: 80.65,
    fill: "#E6E9ED",
    rx: 2.69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.38,
    height: 5.38,
    x: 72,
    y: 80.65,
    fill: "#E6E9ED",
    rx: 2.69
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 22.418,
    height: 5.38,
    x: 49.582,
    y: 60.923,
    fill: "#89A8F8",
    rx: 2.69
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.686,
    cy: 47.657,
    r: 9.257,
    fill: "#5981E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M64.408 46.237a3.722 3.722 0 1 1-7.445 0 3.722 3.722 0 0 1 7.445 0m-.93 0a2.792 2.792 0 1 1-5.584 0 2.792 2.792 0 0 1 5.583 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.686 50.89c-2.053 0-3.532.483-4.579 1.253-1.048.772-1.62 1.798-1.916 2.803a.465.465 0 0 0 .892.263c.253-.857.727-1.691 1.575-2.316.85-.625 2.121-1.073 4.028-1.073s3.177.448 4.027 1.073c.849.625 1.322 1.46 1.575 2.316a.465.465 0 1 0 .893-.264c-.297-1.004-.868-2.03-1.917-2.802-1.047-.77-2.525-1.253-4.578-1.253"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 37.58,
    height: 29.486,
    x: 90.514,
    y: 80.78,
    fill: "#fff",
    rx: 5,
    transform: "rotate(-90 90.514 80.78)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 22.548,
    height: 3.469,
    x: 93.983,
    y: 68.061,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 9.25,
    height: 3.469,
    x: 93.983,
    y: 74.42,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.469,
    height: 3.469,
    x: 113.062,
    y: 74.42,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 14.454,
    height: 3.469,
    x: 98.608,
    y: 61.701,
    fill: "#89A8F8",
    opacity: 0.5,
    rx: 1.734
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.6,
    cy: 52.8,
    r: 6.171,
    fill: "#89A8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M108.119 51.918c0 1.299-1.128 2.351-2.519 2.351s-2.519-1.052-2.519-2.35c0-1.3 1.128-2.352 2.519-2.352s2.519 1.053 2.519 2.351m-.63 0c0 .974-.846 1.764-1.889 1.764s-1.889-.79-1.889-1.764.846-1.763 1.889-1.763 1.889.79 1.889 1.763",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.6 54.857c-1.389 0-2.39.305-3.098.792a3.3 3.3 0 0 0-1.297 1.77c-.049.155.046.319.213.365a.32.32 0 0 0 .391-.199 2.72 2.72 0 0 1 1.066-1.463c.575-.395 1.435-.677 2.725-.677s2.15.282 2.725.677.895.922 1.066 1.463a.32.32 0 0 0 .391.199c.167-.046.262-.21.213-.365a3.3 3.3 0 0 0-1.297-1.77c-.708-.487-1.709-.792-3.098-.792"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 37.58,
    height: 29.486,
    y: 80.78,
    fill: "#fff",
    rx: 5,
    transform: "rotate(-90 0 80.78)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 22.548,
    height: 3.469,
    x: 3.469,
    y: 68.061,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 9.25,
    height: 3.469,
    x: 3.469,
    y: 74.42,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.469,
    height: 3.469,
    x: 22.548,
    y: 74.42,
    fill: "#E6E9ED",
    rx: 1.734
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 14.454,
    height: 3.469,
    x: 8.094,
    y: 61.701,
    fill: "#89A8F8",
    opacity: 0.5,
    rx: 1.734
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#MembershipEmptyStateEdit_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 29,
    r: 16,
    fill: "#D6342C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.507 31.416a.65.65 0 0 1-.647.614h-1.68a.65.65 0 0 1-.647-.614l-.544-10.369a.65.65 0 0 1 .647-.681h2.768c.37 0 .666.31.647.681zm-3.602 4.698q0-1.125.611-1.565.612-.465 1.492-.465.856 0 1.467.465.61.44.611 1.565 0 1.076-.611 1.565-.612.465-1.467.464-.88 0-1.492-.464-.61-.49-.611-1.565"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.086,
    cy: 52.8,
    r: 6.171,
    fill: "#89A8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.605 51.918c0 1.299-1.128 2.351-2.52 2.351-1.39 0-2.518-1.052-2.518-2.35 0-1.3 1.127-2.352 2.519-2.352 1.39 0 2.519 1.053 2.519 2.351m-.63 0c0 .974-.846 1.764-1.89 1.764-1.043 0-1.889-.79-1.889-1.764s.846-1.763 1.89-1.763c1.043 0 1.889.79 1.889 1.763",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.086 54.857c-1.39 0-2.39.305-3.099.792a3.3 3.3 0 0 0-1.296 1.77c-.05.155.045.319.212.365s.342-.043.391-.199a2.72 2.72 0 0 1 1.067-1.463c.575-.395 1.435-.677 2.725-.677s2.15.282 2.725.677c.574.395.895.922 1.066 1.463.05.156.224.245.391.199s.262-.21.213-.365a3.3 3.3 0 0 0-1.297-1.77c-.709-.487-1.71-.792-3.098-.792"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "MembershipEmptyStateEdit_svg__a",
    width: 65.732,
    height: 78.286,
    x: 27.029,
    y: 30.229,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect1_dropShadow_12123_15495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12123_15495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_12123_15495",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "MembershipEmptyStateEdit_svg__b",
    width: 83.826,
    height: 83.826,
    x: 40.087,
    y: 7.817,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 15.548,
    result: "effect1_dropShadow_12123_15495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.73
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.73
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12123_15495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_12123_15495",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembershipEmptyStateEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "35af211d712ff9663921a91452408b0f.svg";